import { REDUCER_NAME } from './const'
import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const TREATMENT_PLAN_LOADED = NS + 'TREATMENT_PLAN_LOADED'

export const CHANGE_TREATMENT_PLAN = NS + 'CHANGE_TREATMENT_PLAN'

export const CHANGE_SEGMENT = NS + 'CHANGE_SEGMENT'


export const SAVE_TREATMENT_PLAN_REQUEST = NS + 'SAVE_TREATMENT_PLAN_REQUEST'
export const SAVE_TREATMENT_PLAN_SUCCESS = NS + 'SAVE_TREATMENT_PLAN_SUCCESS'
export const SAVE_TREATMENT_PLAN_ERROR = NS + 'SAVE_TREATMENT_PLAN_ERROR'



// WEBPACK FOOTER //
// ./src/modules/treatment/state/plan/type.js